export default __webpack_public_path__ + "static/media/night.6cf4adcd.svg";